export default __webpack_public_path__ + "static/press-awards-utica-4168cae5e7352615c90e73cecc965474.png";